import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalsService } from '@ex/module/core/services/globals.service';
import { PlatformUserService } from '@ex/module/core/services/platform-user.service';
import { ModuleName } from '@ex/module/shared/enums/ModuleName';
import { TranslatePipe } from '@ex/module/shared/pipes/translate.pipe';
import { DATA_TOKEN, ICDKPortalComponent } from '@ex/module/shared/Theme/services/zen-cdk.service';
import { ZenSnackbarService } from '@ex/module/shared/Theme/services/zen-snackbar.service';
import { Subscription } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';
@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements OnInit, OnDestroy, ICDKPortalComponent {

  @Output()
  close: EventEmitter<any> = new EventEmitter();

  @Output()
  results: EventEmitter<any> = new EventEmitter();

  subscription = new Subscription();

  hide = true

  form = new FormGroup({
    newEmail: new FormControl("", [Validators.required, Validators.minLength(8)])
  })

  newPassword: string = '';
  userKey: string = '';
  language: string = '';
  ModuleNames = ModuleName
  user: any
  generatedPassword: string = '';

  constructor(@Inject(DATA_TOKEN) data: { user: any, language: string }
    , private platformUserService: PlatformUserService
    , private snackbarService: ZenSnackbarService
    , private globalService: GlobalsService,
    private clipboard: Clipboard
    , private translatePipe: TranslatePipe) {

    this.user = data.user;
    this.userKey = data.user.key;
    this.language = data.language;
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {

  }

  closeModal() {
    this.close.emit("close");
  }

  changeEmail() {
    const formData = this.form.value;

    if (!this.form.valid) {
      this.snackbarService.error(this.translatePipe.transform("txtChangeEmailformInvalid", this.language, this.ModuleNames.Common));
      return;
    }

    const sub = this.platformUserService.changeEmail({
      userKey: this.userKey,
      newEmail: formData.newEmail
    }).subscribe(response => {
      this.snackbarService.success(this.translatePipe.transform("txtChangeEmailSuccess", this.language, this.ModuleNames.Common));
      this.results.emit(true);
    }, err => {
      this.snackbarService.error(this.translatePipe.transform("txtChangeEmailFailed", this.language, this.ModuleNames.Common));
      this.form.reset();
    });

    this.subscription.add(sub);

  }

}
